import { render, staticRenderFns } from "./ProductGifts.vue?vue&type=template&id=0419a2f1&scoped=true&"
import script from "./ProductGifts.vue?vue&type=script&lang=js&"
export * from "./ProductGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419a2f1",
  null
  
)

export default component.exports